// import { ComponentRenderHooks, ListItemsHooks } from "@launchos/plugins/types";
import { ComponentTypes } from "@/Apps/Pages/Editor/types";
import Divider, { Properties } from "./component";
import settings from "./settings";
import { ComponentRenderHooks, ListItemsHooks } from "@/plugins/types";
// import { ComponentTypes } from "../../types";

export const onListItems = (hook, payload, actions) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT) {
    return [settings];
  }
};

export const onComponentRender = (hook, payload, actions) => {
  if (
    hook.id === ComponentRenderHooks.WEBCOMPONENT &&
    payload.type === ComponentTypes.DIVIDER
  ) {
    return [Divider];
  }

  if (
    hook.id === ComponentRenderHooks.PROPERTIES &&
    hook.type === ComponentTypes.DIVIDER
  ) {
    return Properties(payload);
  }
};
